import {useEffect, useRef} from 'react';
import {setCurrentStep, resetRewardsData} from '@/store/slices/rewardsSlice';

// rewardId is accepted for API compatibility (callers pass it) but not used - we always load by route id
export const useLoadDraftFromRoute = ({id, rewardId, loadDraft, dispatch}) => {
  void rewardId;
  const lastLoadedIdRef = useRef(null);
  const isLoadingDraftRef = useRef(false);

  useEffect(() => {
    if (!id) return;

    // Always load when route id is present and we haven't already loaded this id in this mount
    if (String(lastLoadedIdRef.current) === String(id)) return;

    if (
      isLoadingDraftRef.current &&
      String(lastLoadedIdRef.current) === String(id)
    )
      return;

    const initFromRoute = async () => {
      isLoadingDraftRef.current = true;
      lastLoadedIdRef.current = id;
      dispatch(resetRewardsData());
      await loadDraft(id);
      dispatch(setCurrentStep(4));
      isLoadingDraftRef.current = false;
    };

    initFromRoute();
  }, [id, loadDraft, dispatch]);
};
